const LOCAL_API_URL = 'http://127.0.0.1:3001/api/v1'

/**
 * Resolves the API base URL: an explicit `api_url` in localStorage wins;
 * otherwise, when served from a `<branch>.frontend.<domain>` test host,
 * the matching `<branch>.backend.<domain>` is used; else localhost.
 */
export function getApiUrl(): string {
  const stored = localStorage.getItem('api_url')
  if (stored) return stored

  const { protocol, hostname } = window.location
  if (hostname.includes('.frontend.')) {
    return `${protocol}//${hostname.replace('.frontend.', '.backend.')}/api/v1`
  }
  return LOCAL_API_URL
}
